import {NgClass} from "@angular/common";
import {Component, EventEmitter, inject, OnInit} from '@angular/core';

import {ToastrService} from "ngx-toastr";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {AdType} from "@numizmat/enumerations";
import {environment} from "@numizmat/environments";
import {ImageComponent} from "@numizmat/components";
import {ForceRepaintDirective} from "@numizmat/directives";
import {ProfileAdLikeApiService, UserAdLikeApiService} from "@numizmat/services/core";
import {DeleteGroupUserAdLikesRequest, ProfileAdLikeResponse} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-profile-ad-likes-group-actions-modal',
  imports: [
    ForceRepaintDirective,
    ImageComponent,
    NgClass
  ],
  templateUrl: './profile-ad-likes-group-actions-modal.component.html',
  styleUrl: './profile-ad-likes-group-actions-modal.component.scss'
})
export class ProfileAdLikesGroupActionsModalComponent implements OnInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private toastrService: ToastrService = inject(ToastrService);
  private userAdLikeApiService: UserAdLikeApiService = inject(UserAdLikeApiService);
  private profileAdLikeApiService: ProfileAdLikeApiService = inject(ProfileAdLikeApiService);

  protected mode!: 'delete';
  protected loadingData: boolean = true;
  protected loadingSubmit: boolean = false;
  protected adLikes: ProfileAdLikeResponse[] = [];
  protected selectedAdLikeIds: string[] = [];
  protected reloadData: EventEmitter<boolean> = new EventEmitter();

  protected readonly AdType = AdType;
  protected readonly environment = environment;

  public ngOnInit(): void {
    this.getAllProfileAdLikes();
  }

  protected onSubmit(): void {
    if (this.selectedAdLikeIds.length === 0) {
      return;
    }
    this.loadingSubmit = true;
    if (this.mode === 'delete') {
      this.deleteGroupUserAdLikes();
    }
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  protected toggleSelection(adLikeId: string): void {
    const index: number = this.selectedAdLikeIds.findIndex(x => x === adLikeId);
    if (index >= 0) {
      this.selectedAdLikeIds.splice(index, 1);
    } else {
      this.selectedAdLikeIds.push(adLikeId);
    }
  }

  protected toggleSelectAll(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedAdLikeIds = this.adLikes.map(x => {
        return x.userAdLikeId
      });
    } else {
      this.selectedAdLikeIds = [];
    }
  }

  protected areAllSelected(): boolean {
    return this.adLikes.length !== 0 && this.selectedAdLikeIds.length === this.adLikes.length;
  }

  private getAllProfileAdLikes(): void {
    this.profileAdLikeApiService.getAllProfileAdLikes().subscribe({
      next: response => {
        this.loadingData = false;
        this.adLikes = response;
      }
    });
  }

  private deleteGroupUserAdLikes(): void {
    const request: DeleteGroupUserAdLikesRequest = {
      userAdLikeIds: this.selectedAdLikeIds
    };
    this.userAdLikeApiService.deleteGroupUserAdLikes(request).subscribe({
      next: response => {
        this.loadingSubmit = false;
        if (response) {
          this.reloadData.emit(true);
          this.toastrService.success('Успешно изтрихте известия.');
        } else {
          this.toastrService.error('Възникна грешка.');
        }
        this.closeModal();
      }
    });
  }
}
